<template>
    <v-card v-if="showOpportunities" elevation="2" class="pa-4">
        <v-card-title class="text-h6 font-weight-bold justify-center">
            Opportunities in Pipeline
        </v-card-title>
        <v-card-text class="d-flex justify-center">
            <div style="position: relative; height: 300px; width: 300px;">
                <canvas ref="pipelineChart"></canvas>
            </div>
        </v-card-text>
    </v-card>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import Chart from 'chart.js/auto'

const pipelineChart = ref(null)
let chartInstance = null

const API_URL = process.env.VUE_APP_VORTEX_PORTAL_WS + '/partner/opps'
const partnerGUID = localStorage.getItem('partnerGuid') || '';
const showOpportunities = ref(false)

async function fetchPipelineData() {
    try {

        const response = await fetch(API_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ partnerGUID })
        })
        const data = await response.json()

        const oppsStats = data.partnerDashboard?.oppsStats
        if (!oppsStats || data.oppsTotal === 0 ) {
            return
        }
        showOpportunities.value = true;

        const commit = oppsStats['Commit'] || 0
        const evaluation = oppsStats['Evaluation'] || 0
        const proposal = oppsStats['Proposal'] || 0

        drawChart([commit, evaluation, proposal])
    } catch (error) {
        console.error('Error fetching pipeline data:', error)
    }
}

function drawChart(dataArray) {
    if (!pipelineChart.value) {
        console.error('Canvas element not available')
        return
    }

    if (chartInstance) {
        chartInstance.destroy()
    }

    chartInstance = new Chart(pipelineChart.value, {
        type: 'doughnut',
        data: {
            labels: ['Commit', 'Evaluation', 'Proposal'],
            datasets: [{
                data: dataArray,
                backgroundColor: ['#E64A19', '#FBC02D', '#37474F']
            }]
        },
        options: {
            cutout: '50%',
            plugins: {
                legend: {
                    position: 'bottom'
                }
            },
            responsive: true
        }
    })
}

onMounted(fetchPipelineData)
</script>
